import React, { useEffect, useState, Fragment } from "react";
import { ResourceRequester } from "sulu-admin-bundle/services";
import EventCard from "./EventCard";
import { toJS } from "mobx";
import style from "./ReportEvents.scss";
const getPlayers = async (players, setPlayersInfo) => {
    const locale = "de";
    const playersArr = toJS(players);
    try {
        const playerResponse = await ResourceRequester.getList("contacts", {
            ids: playersArr,
            locale: locale,
            fields: "firstName,lastName",
            flat: true,
        });
        const players = playerResponse._embedded.contacts;
        setPlayersInfo(players);
    } catch (e) {
        console.error(e.message);
    }
};
export default ({ data }) => {
    const events = toJS(data.reportMatchPosts);
    const { homeTeam, awayTeam } = data;
    const totalQuarters = 4;
    const [playersInfo, setPlayersInfo] = useState([]);
    const [staffInfo, setStaffInfo] = useState(
        Object.values(toJS(data.allMatchStaff))
    );
    useEffect(() => {
        getPlayers([...data.playersHome, ...data.playersAway], setPlayersInfo);
    }, [data.playersHome, data.playersAway]);

    return (
        <>
            <div className={style["event__header"]}>
                <h3>{data.homeTeamName}</h3>
                <h3>{data.awayTeamName}</h3>
            </div>
            {events.map((event, index, array) => {
                const isQuarterChanged =
                    index > 0 && event.quarter !== array[index - 1].quarter;
                const dividerStyle =
                    event.quarter === 3
                        ? style["event__halftime-divider"]
                        : style["event__quarter-divider"];
                return (
                    <Fragment key={event.id}>
                        {isQuarterChanged && (
                            <div className={dividerStyle}></div>
                        )}
                        <div className={style.event}>
                            <EventCard
                                data={event.team === homeTeam ? event : null}
                                playersInfo={playersInfo}
                                staffInfo={staffInfo}
                            />
                            <span style={{ fontWeight: 700, color: "#919191" }}>
                                {event.quarter
                                    ? `${event.quarter}/${totalQuarters}`
                                    : "SO"}
                            </span>
                            <EventCard
                                data={event.team === awayTeam ? event : null}
                                playersInfo={playersInfo}
                                staffInfo={staffInfo}
                            />
                        </div>
                    </Fragment>
                );
            })}
        </>
    );
};
